<template>
    <div class="users-list">
        <div class="users-list__title-box">
            <h2 class="users-list__title">Список пользователей ({{sortUsers.length}})</h2>
            <button-component class="users-list__button" buttonText="Добавить пользователя" @click="router.push({name: 'newUser'})" />
        </div>
        <div class="users-list__sort-box">
            <div class="users-list__select-box sort" @click="openDropdown('d1')">
                <span>Сначала новые</span>
                <div class="users-list__select-box_dropdown" data-id="d1">
                    <span @click="selectSort($event)">Сначала новые</span>
                    <span @click="selectSort($event)">Сначала старые</span>
                    <span @click="selectSort($event)">По ФИО (А–Я)</span>
                    <span @click="selectSort($event)">По ФИО (Я–А)</span>
                    <span @click="selectSort($event)">По логину (A–Z)</span>
                    <span @click="selectSort($event)">По логину (Z–A)</span>
                </div>
            </div>
            <div class="users-list__select-box role" @click="openDropdown('d2')">
                <span>{{printSelectedRoles()}}</span>
                <div class="users-list__select-box_dropdown multiple" data-id="d2">
                    <label>
                        <input type="checkbox" name="role" value="Все роли" @change="clearRoles('d2')" checked>
                        Все роли
                    </label>
                    <label>
                        <input type="checkbox" name="role" value="Пользователь" @change="selectRole($event, 'd2')">
                        Пользователь
                    </label>
                    <label>
                        <input type="checkbox" name="role" value="Менеджер" @change="selectRole($event, 'd2')">
                        Менеджер
                    </label>
                    <label>
                        <input type="checkbox" name="role" value="Главный менеджер" @change="selectRole($event, 'd2')">
                        Главный менеджер
                    </label>
                    <label>
                        <input type="checkbox" name="role" value="Администратор" @change="selectRole($event, 'd2')">
                        Администратор
                    </label>
                </div>
            </div>
        </div>
        <ul class="users-list__list">
            <li class="users-list__item" v-for="(user, index) in sortUsers" :key="index">
                <div class="users-list__content">
                    <span class="users-list__text users-list__text-black" v-if="user.contacts">{{user.contacts.fullname}}</span>
                    <span class="users-list__text users-list__text">{{user.role}}</span>
                    <span class="users-list__text users-list__text">{{user.login}}</span>
                    <span class="users-list__text users-list__text">{{user.email}}</span>
                </div>
                <div class="users-list__action-box">
                    <VDropdown>
                        <button class="users-list__action">
                            <icon-component class="users-list__icon" name="action" width="22" height="22"/>
                        </button>
                        <template #popper>
                            <div class="users-list__option-box">
                                <button class="users-list__option">Подробнее</button>
                                <button class="users-list__option error" @click="deleteUser(user._id)">Удалить пользователя</button>
                            </div>
                        </template>
                    </VDropdown>
                </div>
            </li>
        </ul>  
    </div>
    <pagination></pagination>
</template>
<script setup lang="ts">
import iconComponent from './iconComponent.vue'
import buttonComponent from './buttonComponent.vue'
import pagination from '../shared/pagination.vue'
import axios from '../app/lib/api'
import { User, UserRole } from '../app/lib/types/users'
import { ref, onMounted, computed } from 'vue'
import {indexOf, sortBy} from 'lodash'
import router from '../app/router/router'
import toast from '../app/lib/hooks/errorToast'
import {useLoadingStore} from '../app/store/store'

const sort = [
    "по ФИО",
    "по логину",
    "по Email",
    "по дате создания",
]
const selected = ref("Сортировка")
const roles = [
    "Администратор",
    "Главный менеджер",
    "Менеджер",
    "Исполнитель",
    "Все"
]
const loading = useLoadingStore()
const role = ref("Роль")
const updateRoles = Object.values(UserRole)
const userRole = localStorage.getItem("role")
const users = ref([] as unknown as User[])
const sortUsers = ref([] as unknown as User[])
const selectedRoles = ref([] as unknown as string[])

function openDropdown(id: string) {
    document.querySelector('.users-list__select-box_dropdown[data-id="' + id + '"]')?.classList.toggle('active')
}

function selectSort(event: Event) {
    let element = event.target as HTMLElement
    let targetText = element.closest('.users-list__select-box.sort') as HTMLElement
    let targetDropdown = element.closest('.users-list__select-box_dropdown.active') as HTMLElement
    if (targetText.children[0]) {
        (targetText.children[0] as HTMLElement).innerText = element?.innerText
    }
    if (targetDropdown.children[1]) {
        targetDropdown.children[1].classList.remove('active')
    }
}

function printSelectedRoles() {
    if (selectedRoles.value.length === 0) {
        return 'Все роли'
    }
    else {
        return `Выбрано: ${selectedRoles.value.length}`
    }
}

function clearRoles(id: string) {
    selectedRoles.value = [] as unknown as string[]
    (document.querySelectorAll(`[data-id=${id}] input`) as NodeListOf<HTMLInputElement>).forEach((input: HTMLInputElement) => {
        input.checked = input.value === 'Все роли'
    })
}

function selectRole(event: Event, id: string) {
    let element = event.target as HTMLInputElement
    (document.querySelector(`[data-id=${id}] input`) as HTMLInputElement).checked = false
    if (!selectedRoles.value.includes(element.value)) {
        selectedRoles.value.push(element.value)
    }
    else {
        selectedRoles.value = selectedRoles.value.filter((role: string) => role !== element.value)
    }
}

function updateRole(id: string, role: UserRole) {
    loading.loading()
    axios.users.updateUserRole(id, role)
    .then(() => {
        const user = sortUsers.value.find(user => user._id === id )
        if(user){
            user.role = role
        }
        loading.load()
    })
    .catch(() => {
        loading.load()
        toast("error", "Не удалось изменить роль")
    })
}

function deleteUser(id: string,) {
    loading.loading()
    axios.users.deleteUser(id)
    .then(() => {
        toast("success", "Пользователь успешно удален")
        sortUsers.value = sortUsers.value.filter(user => user._id !== id)
        loading.load()
    })
    .catch((err: any) => {
        loading.load()
        toast("error", "Не удалось удалить пользователя")
    })
}

const filterRoleUsers = ref([] as unknown as User[])
const filteredRoles = computed(() => {
    const filteredRoles = users.value
    switch (role.value) {
        case "Исполнитель":
            filterRoleUsers.value = filteredRoles
            filterRoleUsers.value = filteredRoles.filter(item => item.role === "Исполнитель")
            sortUsers.value = filterRoleUsers.value
        break;
        case "Главный менеджер":
            filterRoleUsers.value = filteredRoles
            filterRoleUsers.value = filteredRoles.filter(item => item.role === "Главный менеджер")
            sortUsers.value = filterRoleUsers.value
        break;
        case "Менеджер":
            filterRoleUsers.value = filteredRoles
            filterRoleUsers.value = filteredRoles.filter(item => item.role === "Менеджер")
            sortUsers.value = filterRoleUsers.value
        break;
        case "Администратор":
            filterRoleUsers.value = filteredRoles
            filterRoleUsers.value = filteredRoles.filter(item => item.role === "Администратор")
            sortUsers.value = filterRoleUsers.value
        break;
        default:
            filterRoleUsers.value = filteredRoles
            sortUsers.value = filterRoleUsers.value
    }
    triageUsers
})
const sortingUsers = ref([] as unknown as User[])
const triageUsers = computed(() => {
    const triageUsers = [...filterRoleUsers.value]
    const cleanUser = filterRoleUsers.value
    switch (selected.value) {
        case "по ФИО":
            sortingUsers.value = cleanUser
            sortingUsers.value = sortBy(triageUsers, "contacts.fullname")
            sortUsers.value = sortingUsers.value
        break;
        case "по логину":
            sortingUsers.value = cleanUser
            sortingUsers.value = sortBy(triageUsers, item => item.login.toLowerCase())
            sortUsers.value = sortingUsers.value
        break;
        case "по Email":
            sortingUsers.value = cleanUser
            sortingUsers.value = sortBy(triageUsers, item => item.email.toLowerCase())
            sortUsers.value = sortingUsers.value
        break;
        case "по дате создания":
            sortingUsers.value = cleanUser
            sortingUsers.value = sortBy(triageUsers, item => item.createdAt)
            sortUsers.value = sortingUsers.value
        break;
        default:
            sortingUsers.value = cleanUser
            sortUsers.value = sortingUsers.value
    }
})

onMounted(() => {
    loading.loading()
    axios.users.getUsersList()
    .then((res: any) => {
        users.value  = res.data as User[]
        filterRoleUsers.value = users.value
        sortUsers.value = filterRoleUsers.value
        loading.load()
    })
    .catch((err: any) => {
        loading.load()
    })
})

if(userRole !== UserRole.ADMIN) {
    router.push({name: 'main'})
}
</script>